import { Fragment } from 'react';
import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { store } from './redux/store';
import { Jobs } from './views/Jobs';

const LayoutComponent = () => (
	<Provider store={store}>
		<Fragment>
			<Background />
			<Jobs />
		</Fragment>
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.Jobs)
	.build();

export default Layout;
